import axios, {AxiosResponse} from "axios";
import get from "lodash-es/get";
import { ClientChatResponse } from "app/api/types";
import config from "app/api/axiosConfig";

export default (token: string) =>
	axios.get(`${process.env.REACT_APP_CHAT_HOST}/Api/AdminChat`, config(token))
		.then((response: AxiosResponse) => {
			const chats: ClientChatResponse[] = get(response, "data", {});
			return Promise.resolve(chats)
		})
